import { render, staticRenderFns } from "./Subordinates.vue?vue&type=template&id=76131462"
import script from "./Subordinates.vue?vue&type=script&lang=js"
export * from "./Subordinates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports